import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  SvgIcon,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Close } from '@mui/icons-material';

const FilterIcon = () => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 5h16M7 12h10M10 19h4" />
  </SvgIcon>
);

const controlsSx = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(min(150px, 100%), 1fr))',
  alignItems: 'center',
  gap: 1,
  width: '100%',
  minWidth: 0,
  '& > *': {
    width: '100%',
    minWidth: '0 !important',
    maxWidth: 'none !important',
  },
  '& .MuiButton-root': { minHeight: 40 },
};

const FilterPanel = ({ children, className = '', style }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(false);

  if (!isMobile) {
    return (
      <Stack
        className={className}
        style={style}
        sx={{ ...controlsSx, flex: 1 }}
        aria-label="מסננים"
      >
        {children}
      </Stack>
    );
  }

  return (
    <>
      <Button
        type="button"
        variant="outlined"
        startIcon={<FilterIcon />}
        aria-label="פתיחת מסננים"
        aria-expanded={open}
        onClick={() => setOpen(true)}
        sx={{ width: '100%', minHeight: 42 }}
      >
        מסננים
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            width: 'calc(100% - 24px)',
            maxHeight: 'calc(100dvh - 24px)',
            m: 1.5,
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ p: 2, pb: 1 }}>

          <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }} >
            <Typography >סינון תוצאות</Typography>

            <IconButton onClick={() => setOpen(false)}>
              <Close />
            </IconButton>
          </Stack>

        </DialogTitle>
        <DialogContent sx={{ p: 2, pt: '8px !important' }}>
          <Stack
            className={className}
            style={style}
            sx={{
              ...controlsSx,
              gridTemplateColumns: 'minmax(0, 1fr)',
              '& .MuiInputBase-root': { minHeight: 44 },
            }}
          >
            {children}
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FilterPanel;
